import { useState, useEffect } from "react";

export const useResizeObserver = (ref) => {
    const [dimensions, setDimensions] = useState(null);

    useEffect(() => {
        if (!ref.current) return; // Exit if ref.current is null

        const observeTarget = ref.current;

        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach(entry => {
                setDimensions(entry.contentRect);
            });
        });

        resizeObserver.observe(observeTarget);

        return () => {
            resizeObserver.unobserve(observeTarget);
        };
    }, [ref.current]); // Depend on ref.current to re-run when it changes

    return dimensions;
};